import { AvailableBreak } from '../types/breaks';

/**
 * Updates the availability of breaks based on the elapsed time in milliseconds since the break's initial availableIn time.
 * @param breaks - The breaks to update.
 * @param elapsedTimeInMilliseconds - The elapsed time in milliseconds since the break's initial availableIn time.
 * @returns The updated breaks.
 */
export function getBreaksWithUpdatedTimeOfDayAvailability({
	breaks,
	elapsedTimeInMilliseconds,
}: {
	breaks: AvailableBreak[];
	elapsedTimeInMilliseconds: number | null;
}) {
	if (elapsedTimeInMilliseconds === null) {
		return breaks;
	}

	return breaks.map((breakItem) => {
		if (breakItem.availabilityType === 'time_of_day') {
			return {
				...breakItem,
				availableIn:
					breakItem.availableIn - Math.round(elapsedTimeInMilliseconds / 60000),
			};
		}
		return breakItem;
	});
}
